import { render, staticRenderFns } from "./BookPurchases.vue?vue&type=template&id=5f2c7377&scoped=true&"
import script from "./BookPurchases.vue?vue&type=script&lang=js&"
export * from "./BookPurchases.vue?vue&type=script&lang=js&"
import style0 from "./BookPurchases.vue?vue&type=style&index=0&id=5f2c7377&lang=scss&scoped=true&"
import style1 from "./BookPurchases.vue?vue&type=style&index=1&id=5f2c7377&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c7377",
  null
  
)

export default component.exports